import React, { useState } from "react";
import "./ItinearyContent.css";
import NoDataFound from "../NoDataFound/NoDataFound";
import Skeleton from "react-loading-skeleton";
import {
  formatDate,
  formatDateReusable,
  textDateFormatter,
  textDateFormatterNoAdd,
  textDateFormatterNoAddInIteration,
} from "../../utils/utils";
import moment from "moment";

function ItineraryContent({
  singlePackageData,
  loader,
  bookingData,
  customized = false,
}) {
  const [hideContent, setHideContent] = useState(false);
  const [selectedId, setSelectedId] = useState(false);

  const departureDate = `${bookingData?.departureYear}-${String(
    bookingData?.departureMonth
  ).padStart(2, "0")}-${String(bookingData?.departureDay).padStart(2, "0")}`;

  // console.log("departureDate", departureDate);

  function getDatesInArray(startDate, numberOfDays) {
    const resultArray = [];

    // Validate that startDate is a valid date
    const parsedStartDate = new Date(startDate);
    if (isNaN(parsedStartDate.getTime())) {
      // throw new Error("Invalid start date provided.");
    }

    // Validate that numberOfDays is a positive integer
    if (
      typeof numberOfDays !== "number" ||
      numberOfDays <= 0 ||
      !Number.isInteger(numberOfDays)
    ) {
      // throw new Error("Number of days must be a positive integer.");
    }

    let currentDate = parsedStartDate;

    if (!customized) return resultArray;
    for (let i = 0; i < numberOfDays; i++) {
      resultArray.push(currentDate.toISOString().split("T")[0]);
      currentDate.setDate(currentDate.getDate() + 1);
    }

    return resultArray;
  }

  const resultDateArray = getDatesInArray(departureDate, 40);

  return (
    <>
      {loader ? (
        <div className="package-update-content-containers">
          <div className="package-update-cards">
            <div className="package-card-body">
              {Array.from({ length: 5 }).map((_, index) => (
                <div className="package-update-card" key={index}>
                  <div className="content-consider">
                    <div>
                      <div className="agent">
                        <div className="flex">
                          <span>
                            <Skeleton width={50} />
                          </span>
                          <span style={{ padding: "0 5px" }}>|</span>
                          <strong>
                            <Skeleton width={50} />
                          </strong>
                        </div>
                      </div>
                      <p>
                        <Skeleton />
                      </p>
                      <p>
                        <Skeleton width={700} />
                      </p>
                      <p>
                        <Skeleton width={600} />
                      </p>
                      <p>
                        <Skeleton width={500} />
                      </p>
                      <p>
                        <Skeleton width={400} />
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      ) : (
        <>
          {singlePackageData?.packageItinerary?.length > 0 ? (
            <>
              {singlePackageData?.packageItinerary?.map((items, index) => {
                return (
                  <div className="package-update-card" key={index}>
                    <div className="content-consider">
                      <div>
                        <div className="agent flex_wrap">
                          <div>
                            {" "}
                            <span style={{ fontWeight: "bold" }}>
                              {!customized ? (
                                <span> Day {items.day}</span>
                              ) : resultDateArray[items.day - 1] ? (
                                moment(resultDateArray[items.day - 1]).format(
                                  "MMM Do YYYY"
                                )
                              ) : (
                                // textDateFormatterNoAddInIteration(
                                //   resultDateArray[items.dayCount - 1]
                                // )
                                `Day ${items.day}`
                              )}
                            </span>
                            <span style={{ padding: "0 5px" }}>|</span>
                            <strong>{items?.additionalDetails?.heading}</strong>
                          </div>

                          <div className="package-view-btn">
                            {items?.additionalDetails?.long_description && (
                              <button
                                className="view_btn"
                                onClick={() => {
                                  setSelectedId(
                                    selectedId === items.day ? null : items.day
                                  );
                                }}
                              >
                                {selectedId === items.day
                                  ? "Hide Details"
                                  : "View Details"}
                              </button>
                            )}
                          </div>
                        </div>

                        <div>
                          {selectedId === items.day ? (
                            <p
                              dangerouslySetInnerHTML={{
                                __html:
                                  items?.additionalDetails?.long_description,
                              }}
                            ></p>
                          ) : (
                            <p
                              dangerouslySetInnerHTML={{
                                __html:
                                  items?.additionalDetails?.short_description,
                              }}
                            ></p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </>
          ) : (
            <NoDataFound />
          )}
        </>
      )}
    </>
  );
}

export default ItineraryContent;
